import React, { FC } from 'react'
import { useTranslation } from 'react-i18next';
import "../../../../scss/ProductListHeader.scss"
import { IColumn } from '../../../../yoello-lib/modules/components/PaginatedTable'

interface IProductListHeader {
  columns: IColumn[];
}

const ProductListHeader:FC<IProductListHeader> = ({columns}) => {
  const { t } = useTranslation();
  return (
    <div className={"container"}>
      {
        columns.map(i => (
          <div className={"headerItem"}>
            {t(i.localisedLabel)}
          </div>
        ))
      }
    </div>
  )
}

export default ProductListHeader;